import { render, staticRenderFns } from "./ViewShortlistPage.vue?vue&type=template&id=31c6e2e6&scoped=true&"
import script from "./ViewShortlistPage.vue?vue&type=script&lang=js&"
export * from "./ViewShortlistPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewShortlistPage.vue?vue&type=style&index=0&id=31c6e2e6&lang=sass&scoped=true&"
import style1 from "./ViewShortlistPage.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c6e2e6",
  null
  
)

export default component.exports